export default defineNuxtPlugin(() => {
  const permissions = useState<Record<string, boolean>>(
    'permissions',
    () => ({}),
  );
  const permissionsLoaded = useState<boolean>('permissionsLoaded', () => false);
  const { status } = useAuth();

  watch(
    () => status.value,
    async (newStatus) => {
      if (newStatus !== 'authenticated') {
        permissions.value = {};
        permissionsLoaded.value = true;
        return;
      }

      permissionsLoaded.value = false;

      try {
        const response = await fetchApi<any>('/my-account');
        permissions.value = response?.data?.permissions || {};
      } catch {
        permissions.value = {};
      } finally {
        permissionsLoaded.value = true;
      }
    },
    { immediate: true },
  );
});
